// extracted by mini-css-extract-plugin
export var close = "styles-module--close--8f31d";
export var feedbackButton = "styles-module--feedbackButton--bbf92";
export var feedbackModalWrapper = "styles-module--feedbackModalWrapper--5560c";
export var modal = "styles-module--modal--a7dd5";
export var modalContent = "styles-module--modalContent--14196";
export var noScroll = "styles-module--no-scroll--69192";